// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32siB","badges":"styles_badges__Q8Jth"};